AOS.init({
	duration: 800, 
	offset: 200,
	disable: 'mobile'
});

$(document).ready(function() {

	if($('#ContactForm .form-status').length > 0) {
		setTimeout(function() {
			$('#ContactForm .form-group').removeClass('hidden');
			$('#ContactForm .btn').removeClass('hidden');
		}, 7000);
	}
	//gsap.registerPlugin(SplitText);
	gsap.registerPlugin(ScrollTrigger);
	
	//var split = new SplitText("h3", {type:"words", wordsClass:"word word++"});
	//$(".block-textImage-half h3").lettering();

	//assign specific classes to the elements that will be animated
	$("section:not(.blockQuote)").each(function() {
		$("h1,h2,h3:not(.yellowWave)").each(function() {
			$(this).addClass('lettering');
		});
	});
	$("section h1,section h2,section:not(.blockQuote) h3:not(.yellowWave)").each(function() {
		var index = $(this).index('.lettering');
		$(this).addClass('anim'+index).addClass('animateMe');
		var words = $.trim($(this).text()).split(" ");
		//console.log(words);
		var letteringLines = '';
        for (let i = 0; i < words.length; ++i) {
		    letteringLines += '<span class="letteringLine">'+words[i]+'</span>';
		}
		//console.log(letteringLines);
		$(this).html(letteringLines);
		$(this).find('.letteringLine').lettering();
	});

	$(document).scroll();
	setTimeout(function() {
		$(document).scroll();
	}, 100);
	setTimeout(function() {
		$(document).scroll();
	}, 300);
	

	$('.productSort').click(function() {
		if($(this).hasClass('dropped')) {
			$(this).removeClass('dropped');
		}
		else {
			$(this).addClass('dropped');
		}
		$(this).find('.list').slideToggle();
		//console.log($(this).find('.list'));
	});

	function replaceUrlParam(url, paramName, paramValue)
	{
		if (paramValue == null) {
			paramValue = '';
		}
		var pattern = new RegExp('\\b('+paramName+'=).*?(&|#|$)');
		if (url.search(pattern)>=0) {
			return url.replace(pattern,'$1' + paramValue + '$2');
		}
		url = url.replace(/[?#]$/,'');
		return url + (url.indexOf('?')>0 ? '&' : '?') + paramName + '=' + paramValue;
	}

	$('.productSort .list button').click(function(){
		var url = window.location.href;
		var sort = $(this).attr('data-sort');
		location.href = replaceUrlParam(url, 'sort_by', sort);
	});

	function toggleNavbarMethod() {  
        if ($(window).width() > 768) {  
            $('.navbar .dropdown').on('mouseover', function(){  
                $('.dropdown-toggle', this).trigger('click');   
            }).on('mouseout', function(){  
                $('.dropdown-toggle', this).trigger('click').blur();  
            });  
        }  
        else {  
            $('.navbar .dropdown').off('mouseover').off('mouseout');  
        }  
    }  
    //toggleNavbarMethod();  
    //$(window).resize(toggleNavbarMethod);



	$(document).scroll(function() {
		if(!$('.navbar-toggler-icon').is(':visible')) {
			var t=$(window).scrollTop();

			$('.animateMe').each(function() {
				var index = $(this).index('.lettering');
				//console.log(index);
				
				if($(window).scrollTop() > $(this).offset().top - $(window).height() + 80)
				{
					//$('#header .navItems a.menuItem.selected').removeClass('selected');
					animation('.lettering.animateMe.anim'+index+' .letteringLine span',index);
				}
			});
		}

	});

	$(function() {
		// Initialize form validation on the registration form.
		// It has the name attribute "registration"
		$("#ContactForm").validate({
		  // Specify validation rules
		  rules: {
			// The key name on the left side is the name attribute
			// of an input field. Validation rules are defined
			// on the right side
			"contact[Name]": "required",
			"contact[email]": {
			  required: true,
			  // Specify that email should be validated
			  // by the built-in "email" rule
			  email: true
			},
			"contact[Comment]": "required"
		  },
		  // Specify validation error messages
		  messages: {
			"contact[Name]": "Please enter your full name",
			"contact[email]": "Please enter a valid email address",
			"contact[Comment]": "Please enter a message"
		  },
		  // Make sure the form is submitted to the destination defined
		  // in the "action" attribute of the form when valid
		  submitHandler: function(form) {
			form.submit();
		  }
		});
	});

	//Zoom on hover
	if($('.image-zoom').length) {
		$('.image-zoom')
	    .wrap('<span class="image-zoom-wrap"></span>')
	    .css('display', 'block')
	    .parent()
	    .zoom();
	}

	$('.product-single__photo').on('click', function(evt) {
	  evt.preventDefault();
	});

	$('.product-single__thumbnail').on('click', function(evt) {
	  evt.preventDefault();
	  var imageId = $(this)
	    .parent()
	    .data('image-id');
	  self.setActiveThumbnail(imageId);
	  self.switchProductImage(imageId);
	}
	);
});

function animation(toAnimate,index) {
  var title1 = new TimelineMax();
  //console.log(toAnimate);
  title1.staggerFromTo(toAnimate, 0.4, 
  {ease: Power2.easeOut, opacity: 0, bottom: -40},
  {ease: Power2.easeOut, opacity: 1, bottom: 0}, 0.04);
  //console.log('completed animation: ' + toAnimate + ', ' + $(toAnimate).parent());
  $('.anim'+index).removeClass('animateMe');
  //console.log('completed animation: ' + $(toAnimate).parent().removeClass);
}





function setActiveThumbnail(imageId) {

  $(".thumbnails .product-single__thumbnail-item[data-image-id='" + imageId + "']").removeClass('is-active');
  $(".thumbnails .product-single__thumbnail-item:not([data-image-id='" + imageId + "'])").addClass('is-active');

  //var $thumbnails = $(this.selectors.productThumbsWrapper, this.$container);

  /*
  // If there is a slick carousel, get the slide index, and position it into view with animation.
  if ($thumbnails.hasClass('slick-initialized')) {
    // eslint-disable-next-line shopify/jquery-dollar-sign-reference
    var currentActiveSlideIndex = $thumbnails.slick('slickCurrentSlide');
    var newActiveSlideIndex = parseInt(
      $thumbnailToShow.attr('data-slick-index')
    );
    if (currentActiveSlideIndex !== newActiveSlideIndex) {
      $thumbnails.slick('slickGoTo', newActiveSlideIndex, false);
    }
  }
  */
}

function switchProductImage(imageId) {

  	$(".productImages .product-single__photo:not([data-image-id='" + imageId + "'])").addClass('hide');
  	$(".productImages .product-single__photo[data-image-id='" + imageId + "']").removeClass('hide');
}